// src/components/ProductPage/SizeSelector.js
import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const SizeSelector = ({ 
  availableSizes, 
  selectedSize, 
  handleSizeChange 
}) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography 
        variant="h6" 
        sx={{ 
          mb: 2,
          fontWeight: 'bold',
          color: '#333'
        }}
      >
        المقاس:
      </Typography>
      <Box sx={{ 
        display: 'flex', 
        gap: 1.5, 
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
        flexDirection: 'row-reverse',
        width: '100%',
        mt: 1
      }}>
        {availableSizes.map(sizeItem => (
          <Button 
            key={sizeItem.id}
            variant={selectedSize === sizeItem.size ? 'contained' : 'outlined'} 
            onClick={() => handleSizeChange(sizeItem.size)} 
            disabled={sizeItem.stock < 1}
            sx={{
              minWidth: 60,
              height: 48,
              borderRadius: 2,
              fontWeight: 'bold',
              ...(selectedSize === sizeItem.size && {
                backgroundColor: '#0f3662',
                '&:hover': { backgroundColor: '#0a2a4a' }
              }),
              ...(selectedSize !== sizeItem.size && {
                borderColor: '#0f3662',
                color: '#0f3662',
                '&:hover': {
                  borderColor: '#0f3662',
                  backgroundColor: 'rgba(15, 54, 98, 0.04)'
                }
              })
            }}
          >
            {sizeItem.size}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

export default SizeSelector;
